import "./accordion.css"
import Accordion from "./Accordion"
import AccordionItem from "./AccordionItem"
import AccordionTrigger from "./AccordionTrigger"
import AccordionContent from "./AccordionContent"

export type { AccordionProps } from "./Accordion"
export type { AccordionItemProps } from "./AccordionItem"
export type { AccordionTriggerProps } from "./AccordionTrigger"
export type { AccordionContentProps } from "./AccordionContent"

export default Object.assign(Accordion, {
  Item: AccordionItem,
  Trigger: AccordionTrigger,
  Content: AccordionContent,
})
